module.exports = __webpack_public_path__ + "static/184_gan-1c9c680085db0368e858829f77032da8.jpg";